/**
 * Application Configuration Constants
 */

export const APP_CONFIG = {
  name: 'Neurix Lab',
  company: 'Maersk',
};

export const FILE_UPLOAD = {
  acceptedFormats: 'application/pdf,.txt,.xlsx,.xls,.xlsm,text/plain',
  maxSize: 50 * 1024 * 1024, // 50MB (Python backend supports larger uploads)
};

export const API_ENDPOINTS = {
  backend: 'https://api.maersk.com/neurix-lab',
  chunkingService: 'https://api.maersk.com/neurix-lab',
};

// Database configuration (for Python backend)
export const DATABASE_CONFIG = {
  host: process.env.REACT_APP_DB_HOST || 'localhost',
  port: process.env.REACT_APP_DB_PORT || 5432,
  database: process.env.REACT_APP_DB_NAME || 'opticuslab',
};

export const DOCUMENT_RECONSTRUCTION = {
  widthChars: 250,
  heightLines: 1000,  // Increased from 200 to handle large Excel files
};
